import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ModelAttributes } from '@app/core/interface/common';
import { SnackNotifier } from '@app/shared/notifier/snack-notifier';
import { ActivatedRoute } from '@angular/router';
import { environment } from '@env/environment';
import { CRITICAL_INFO_TYPE } from '@app/modules/critical-info/consts/type';

const CRITICAL_INFO = [
  { propertyName: CRITICAL_INFO_TYPE.geneticTesting, title: 'Genetic testing', changedTo: null, icon: 'i-23' },
  { propertyName: CRITICAL_INFO_TYPE.intubation, title: 'Intubation', changedTo: null, icon: 'i-49' },
  { propertyName: CRITICAL_INFO_TYPE.organDonation, title: 'Organ donation', changedTo: null, icon: 'i-31' },
  { propertyName: CRITICAL_INFO_TYPE.resuscitation, title: 'Resuscitation', changedTo: null, icon: 'i-33' }
];

@Component({
  templateUrl: './public-patient-info.component.html',
  styleUrls: ['./public-patient-info.component.sass']
})
export class PublicPatientInfoPageComponent implements OnInit {
  public model: ModelAttributes;

  public criticalInfoAccepted: ModelAttributes[] = [];

  public criticalInfoDeclined: ModelAttributes[] = [];

  public criticalInfoNoAnswer: ModelAttributes[] = [];

  /**
   * @param http
   * @param snack
   * @param route
   */
  constructor(
    private readonly http: HttpClient,
    private readonly snack: SnackNotifier,
    private readonly route: ActivatedRoute
  ) {}

  public ngOnInit(): void {
    const userId = this.route.snapshot.params.id;

    this.getPublicInfo(userId)
      .subscribe(
        (response: ModelAttributes) => {
          this.model = response;

          for (const criticalInfo of CRITICAL_INFO) {
            let item = criticalInfo;
            for (const update of response.criticalInfoRecentUpdates) {
              if (update.propertyName === criticalInfo.propertyName) {
                item = { ...item, ...update};
                break;
              }
            }

            switch (item.changedTo) {
              case true:
                this.criticalInfoAccepted.push(item);
                break;
              case false:
                this.criticalInfoDeclined.push(item);
                break;
              default:
                this.criticalInfoNoAnswer.push(item);
            }
          }
        },
        ({ error }) => this.snack.error(error),
      );
  }

  public getPublicInfo(userId: string): Observable<ModelAttributes> {
    return this.http.get(`${environment.apiUrl}/accounts/public/${userId}`);
  }
}
